import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem } from '../../../core/interfaces/admin.interface';
import { CouponType } from '../../models/coupon';
import { TranslateService } from '@ngx-translate/core';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-coupon-type-select',
  templateUrl: './coupon-type-select.component.html',
  styleUrls: ['./coupon-type-select.component.scss']
})
export class CouponTypeSelectComponent {

  @Input() typeSelected: MultiselectItem[] = [];

  @Output() typeSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  typeList: MultiselectItem[] = [];

  constructor(
    private translate: TranslateService,
  ) {

    this.typeList = [
      { id: CouponType.AMOUNT, itemName: this.translate.instant('multiselect.couponType.' + CouponType.AMOUNT) },
      { id: CouponType.PERCENTAGE, itemName: this.translate.instant('multiselect.couponType.' + CouponType.PERCENTAGE) }
    ]

  }

  onTypeSelect(): void {
    this.typeSelectedChange.emit(this.typeSelected);
    this.onSelected.emit(this.typeSelected);
  }

}
